import {
  CartContextProvider,
  TravelConfigurationStep,
  TravelConfirmationStep,
  TravelInformationStep,
  TravelInsuranceStep,
  TravelPaymentStep,
  TravelPurchasePage,
  TravelPurchaseProvider,
  TravelSelectionStep,
  TravelValidationStep
} from 'components';
import { ProtectedRoute } from 'router';

export const travelPurchaseRoutes = {
  travelPurchase: {
    path: '/achat-voyage',
    component: () => (
      <ProtectedRoute>
        <CartContextProvider>
          <TravelPurchaseProvider>
            <TravelPurchasePage />
          </TravelPurchaseProvider>
        </CartContextProvider>
      </ProtectedRoute>
    ),
    children: {
      selection: {
        path: '/achat-voyage/selection',
        component: () => (
          <ProtectedRoute>
            <TravelSelectionStep />
          </ProtectedRoute>
        )
      },
      configuration: {
        path: '/achat-voyage/configuration',
        component: () => (
          <ProtectedRoute>
            <TravelConfigurationStep />
          </ProtectedRoute>
        )
      },
      insurance: {
        path: '/achat-voyage/assurance',
        component: () => (
          <ProtectedRoute>
            <TravelInsuranceStep />
          </ProtectedRoute>
        )
      },
      informations: {
        path: '/achat-voyage/informations',
        component: () => (
          <ProtectedRoute>
            <TravelInformationStep />
          </ProtectedRoute>
        )
      },
      validation: {
        path: '/achat-voyage/validation',
        component: () => (
          <ProtectedRoute>
            <TravelValidationStep />
          </ProtectedRoute>
        )
      },
      payment: {
        path: '/achat-voyage/paiement',
        component: () => (
          <ProtectedRoute>
            <TravelPaymentStep />
          </ProtectedRoute>
        )
      },
      confirmation: {
        path: '/achat-voyage/confirmation',
        component: () => (
          <ProtectedRoute>
            <TravelConfirmationStep />
          </ProtectedRoute>
        )
      }
    }
  }
};
